import captureSentryException from '../tracking/sentry/captureSentryException';

const currencyReals = (value, rounded) => {
  try {
    const args = rounded ? {
      style:                 'currency',
      currency:              'BRL',
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    } : {
      style:    'currency',
      currency: 'BRL',
    };

    return Number(value).toLocaleString('pt-BR', args);
  } catch (e) {
    const extras = {
      value,
      rounded,
    };
    captureSentryException(e, extras);
    throw new Error(`Error formatting value to currencyReals: ${e}`);
  }
};
export default currencyReals;
